// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__F6nE8","paramInput":"JobSimulator_paramInput__2X0Ta","input":"JobSimulator_input__3TFvs"};